import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { graphData_api, pujaGraphData_api } from "../api/dashboard";
import s from "./dashboard.module.css";

const PujaChart = ({ settopPujas }) => {
  const [graphData, setgraphData] = useState();
  const [selectedRange, setSelectedRange] = useState("7d");
  console.log(graphData, " graphData graphData graphData graphData graphData ");
  const leadPotData = [
    {
      leadPotential: 200,
      leads: 3,
      color: "#2a88c0",
    },
    {
      leadPotential: 400,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 500,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 200,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 800,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 600,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 300,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 300,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 300,
      leads: 3,
      color: "#24ae6d",
    },
  ];
  const leadPotData1 = [
    {
      leadPotential: 100,
      leads: 3,
      color: "#2a88c0",
    },
    {
      leadPotential: 800,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 300,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 250,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 550,
      leads: 1,
      color: "#e4a92f",
    },
    {
      leadPotential: 450,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 400,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 400,
      leads: 3,
      color: "#24ae6d",
    },
    {
      leadPotential: 400,
      leads: 3,
      color: "#24ae6d",
    },
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Puja Details",
      },
    },
  };
  const optionValue = [
    { label: "Last 7 Days", value: "7d" },
    { label: "Last 30 Days", value: "30d" },
    { label: "Last 12 Months", value: "12m" },
    { label: "This Week", value: "this_week" },
    { label: "This Month", value: "this_month" },
    { label: "Year to Date (YTD)", value: "ytd" },
  ];

  useEffect(() => {
    fetchGraphDataFunc();
  }, [selectedRange]);

  const fetchGraphDataFunc = async () => {
    let temp = { selectedRange };
    const res = await pujaGraphData_api(selectedRange);
    if (res.data.success) {
      console.log(res.data.data, " this is the dashboar data");
      setgraphData(res.data.data);
      settopPujas(res.data.data.top_pujas);
    }
  };

  const labels = graphData?.chart?.map((v) => v.date);

  const data = {
    labels,
    datasets: [
      {
        label: "Puja Data",
        data: graphData?.chart?.map((v) => v.total),
        backgroundColor: "#9e2a2b",
      },
      // {
      //   label: "Dataset 2",
      //   data: leadPotData1.map((v) => v.leadPotential),
      //   backgroundColor: "#d3d3d3",
      // },
    ],
  };

  const [loading, setLoading] = useState(false);
  return (
    <>
      <div style={{ position: "relative" }}>
        <div className={s["filter_position"]}>
          <label>Puja Filter: </label>
          <select
            value={selectedRange}
            onChange={(e) => setSelectedRange(e.target.value)}
          >
            {optionValue.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {loading ? (
            <p>Loading...</p>
          ) : (
            // data && <pre>{JSON.stringify(data, null, 2)}</pre>""
            ""
          )}
        </div>

        {labels && <Bar options={options} data={data} />}
      </div>
    </>
  );
};

export default PujaChart;
